document.addEventListener("DOMContentLoaded", function () {
  const qtyInputs = document.querySelectorAll(".product__info-wrapper .limit_customer .quantity__input");

  qtyInputs.forEach((input) => {
    // Watch for change in `data-cart-quantity` using MutationObserver
    const observer = new MutationObserver(() => {
      updateMax(input);
    });

    observer.observe(input, { attributes: true, attributeFilter: ["data-cart-quantity"] });

    // Run initially
    updateMax(input);

    // Also run whenever user types in the input
    input.addEventListener("input", () => {
      updateMax(input);
    });
  });

  function updateMax(input) {
    console.log("dumy test");
    const cartQty = parseInt(input.getAttribute("data-cart-quantity")) || 0;
    const maxQty = parseInt(input.getAttribute("data-max")) || 0;

    // remaining available qty
    const remaining = Math.max(maxQty - cartQty, 0);

    // update attributes
    input.setAttribute("max", remaining);
    input.setAttribute("data-max", remaining);

    // If user typed more than allowed → reset it
    if (parseInt(input.value) > remaining) {
      input.value = remaining;
    }
  }
});
